import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp, postPushSound} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './AddPushSoundPage.css';
import PushSoundForm from "../../../components/push/PushSoundForm/PushSoundForm";
import {SETTING_PAGE} from "../../../constants/routes";

export class AddPushSoundPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();

    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.postPushSound(this.props.app.id, formProps);
    };

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Push / Add - Sound</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>New Sound</Subheader>

                                <div style={style.paper}>
                                    <PushSoundForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear}/>
                            </Paper>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending,
        error: state.apps.error,
        app: state.apps.currentApplication,
        sending: state.apps.sending
    };
}

export default connect(mapStateToProps, {
    postPushSound,
    fetchApp
})(AddPushSoundPage);



// WEBPACK FOOTER //
// src/containers/push/AddPushSoundPage/AddPushSoundPage.js